// extracted by mini-css-extract-plugin
export default {"invalidIconEmptyCell":"cellTooltip_invalidIconEmptyCell__6ovCO","invalidIcon":"cellTooltip_invalidIcon__Rnx-X"};